import { v1 } from './v1';

export const ai = {
  v1,
};
